import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiUserBlockedError extends TmApiClientError {
  public name = 'TmApiUserBlockedError'

  protected override code: TmTransportHttpErrorCode = 406
}
